
export const REST_PATH = "/wp-json/wp/v2";
